<p-card>
    <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Noch Fragen?</div>
    <div class="border-2 border-300 p-2 text-center">
        Service und Beratung<br />
        <a href="tel:+4968319596335" class="font-semibold text-800 no-underline">06831 9596 - 335</a>
    </div>
</p-card>